import { render, staticRenderFns } from "./customer-manage.vue?vue&type=template&id=4a824430"
import script from "./customer-manage.vue?vue&type=script&lang=js"
export * from "./customer-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports